<template>
    <v-card outlined max-width="140">
        <v-row no-gutters align="center">
            <v-col cols="auto">
                <v-card-subtitle class="py-0 pr-0"> 유형 </v-card-subtitle>
            </v-col>
            <v-col>
                <v-select v-model="query['type']" v-bind="{ items }" dense flat solo hide-details @input="emit" />
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
const USER_DEPOSIT_TYPES = {
    INCREASE: { value: "INCREASE", text: "입금" },
    DECREASE: { value: "DECREASE", text: "출금" },
};
const items = [{ value: null, text: "전체" }].concat(...Object.values(USER_DEPOSIT_TYPES));

const initQuery = (query = {}) => ({
    ...(query || {}),

    ["type"]: query?.["type"] || null,
});

export default {
    components: {},
    data: () => ({
        query: initQuery(),
        items,
    }),
    methods: {
        sync() {
            this.query = initQuery(this.$route.query);
        },
        emit() {
            let { ...query } = this.query;
            delete query["page"];
            if (!query["type"]) delete query["type"];
            this.$router.push({ query });
        },
    },
    watch: {
        $route() {
            this.sync();
        },
    },
    mounted() {
        sync();
    },
};
</script>

<style lang="scss" scoped></style>
